<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-23T10:24:36+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe - Footer for eacxh page
@Last modified by:   tom
@Last modified time: 2018-02-06T10:18:12+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <div id="footer" class="bg-primary">
    <div id="copyright" class="container pl-2">
      <router-link :to="{name:'Upgrade'}" class=""> v{{ version }}&nbsp;&nbsp;</router-link>

      <span v-html="$t('footer.copyright') + ' ' + thisYear + ' ' + $t('footer.terms')"/>
    </div>
  </div>
</template>

<script>

// To use the package.json version number all over your code, please add to webpack.config.js
//   plugins: [
//     new webpack.DefinePlugin({
//       VERSION: JSON.stringify(require("../package.json").version)
//     })
//   ]
/* global VERSION */
console.log('Version: ' + VERSION)

export default {
  computed: {
    thisYear: function () {
      return new Date().getFullYear()
    },
    version: function () {
      return VERSION
    },
    versionUnderScore: function () {
      return VERSION.replace(/\./g, '_')
    }
  }
}

</script>

<style lang="scss" scoped>

  @import "../../assets/style/theme.scss";

  #footer {
    margin: 0;
    padding: 2px;
    border-top: 1px solid $primaryHighlight;
    font-size: 0.9em;

    #copyright {
      font-size: 0.9em;
      padding: 0.5rem 0;
      color: $primaryWhite;
      opacity: 0.6;
      line-height: 1em;
      a {
        color: $primaryWhite;
      }
    }
  }

</style>
